import Cookies from 'js-cookie';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, Header, Image } from 'semantic-ui-react';
import logo from '../logo.png';
import { PATH } from '../routes/CustomRoutes';


export default function NoStoreScreen() {

  const navigate = useNavigate();

  React.useEffect(() => {
    Cookies.remove('user')
    Cookies.remove('token')
  }, [])

  return (
    <div className='not-found'>
      <style>
        {`
          body > div,
          body > div > div,
          body > div > div > div.not-found {
            height: 100%;
          }
        `}
      </style>
        <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle' centered>
          <Grid.Column textAlign='center'>
            <Image src={logo} size='medium' centered/>
            <Header size='large' color='grey'>เครื่องยังไม่ถูกลงทะเบียน โปรดติดต่อผู้ดูแล</Header>
            <Button 
              content='กลับสู่หน้าแรก'
              color='blue'
              size='big'
              icon='arrow left'
              onClick={() => navigate(PATH.LOGIN)}/>
          </Grid.Column>
        </Grid>
    </div>
  )
}